type ZemChargeBenefitInput = {
  baseZem: number;
  bonusZem?: number;
  totalZem?: number;
  promotionType?: string;
};

export const getZemChargeBenefit = ({
  baseZem,
  bonusZem = 0,
  totalZem,
  promotionType,
}: ZemChargeBenefitInput) => {
  const normalizedBonusZem = Math.max(0, bonusZem);

  return {
    baseZem,
    bonusZem: normalizedBonusZem,
    totalZem: totalZem ?? baseZem + normalizedBonusZem,
    promotionType:
      promotionType ?? (normalizedBonusZem > 0 ? 'LEGACY' : 'NONE'),
  };
};
